import { UAParser } from "ua-parser-js";

export const parseUserAgent = userAgent => {
  const parser = new UAParser(userAgent);
  const result = parser.getResult();

  return {
    browser: result.browser.name || "Unknown",
    operating_system: result.os.name || "Unknown",
    device_type: result.device.type || "Desktop",
  };
};
